import { render } from "./ProblemSolvingScreen.vue?vue&type=template&id=50c0b182&scoped=true"
import script from "./ProblemSolvingScreen.vue?vue&type=script&lang=js"
export * from "./ProblemSolvingScreen.vue?vue&type=script&lang=js"

import "./ProblemSolvingScreen.vue?vue&type=style&index=0&id=50c0b182&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c0b182"]])

export default __exports__